

export default function NotFoundPage() {
  return (
    <>       
      <main className="relative isolate min-h-screen">                    
        <div className="mx-auto max-w-7xl px-6 py-32 text-center sm:py-40 lg:px-8">          
          <h1 className="mt-4 text-balance text-5xl font-semibold tracking-tight text-black sm:text-7xl">
            Pagina no encontrada
          </h1>
          <p className="mt-6 text-pretty text-lg font-medium text-black/70 sm:text-xl/8">
            Lo sentimos, no pudimos encontrar la página que estás buscando
          </p>
          <div className="mt-10 flex justify-center">
            <a href="https://parquemonchis.com" className="text-sm/7 font-semibold text-black">
              <span aria-hidden="true">&larr;</span> Regresar
            </a>
          </div>
        </div>
      </main>
    </>
  )
}
